import { createFileRoute } from '@tanstack/react-router'

import { StoreSettingsLayout } from '@/features/store-settings/components/StoreSettingsLayout'

/** Store Settings shell; sections render in the outlet. */
export const Route = createFileRoute('/_authed/settings')({
  component: StoreSettingsLayout,
})
